/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import { CardBody } from './components/CardBody';
import { CardFooter } from './components/CardFooter';
import './AIGeneralBlockCardStyles.scss';
const baseClass = 'qmb-ui-ai-general-block-card';
/**
 * AIGeneralBlockCard Organism
 * A reusable card component for AI response blocks with body sections + footer toolbar.
 * Used by ConfirmationRenderer, CitationRenderer, ChartRenderer, RecordCardRenderer,
 * DataTableRenderer, and others.
 *
 * @example
 * ```tsx
 * <AIGeneralBlockCard
 *   sections={[{ label: 'Building', content: 'Building A (123 Main St)', copyText: 'Building A' }]}
 *   footerGroups={[{ actions: [{ id: 'copy', label: 'Copy', icon: 'fa-light fa-copy', onClick: handleCopy }] }]}
 * />
 * ```
 *
 * @version 1.0.0
 * @since 2026-02-18
 */
export function AIGeneralBlockCard({ sections = [], footerGroups = [], variant = 'default', className, children }) {
    return (React.createElement("article", { className: classNames(baseClass, `${baseClass}--${variant}`, className), "aria-label": "Content card" },
        sections.length > 0 && React.createElement(CardBody, { sections: sections, variant: variant }),
        children,
        footerGroups.length > 0 && React.createElement(CardFooter, { groups: footerGroups })));
}
